// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3119eb48","455":"1bffdb89"}[chunkId] + ".chunk.js";
};